export type ProjectSearchDateOperator = 'before' | 'on' | 'after';
export type ProjectSearchCommentsFilter = '' | 'unread';
export type ProjectSearchTagMatch = 'any' | 'all';
export type ProjectSearchVisibilityFilter =
  | ''
  | 'members_only'
  | 'members_and_clients';
export const PROJECT_SEARCH_PUBLIC_FEEDBACK_CREATED_BY = 'public_feedback';

export const readProjectSearchVisibility = (
  value: string | null
): ProjectSearchVisibilityFilter =>
  value === 'members_only' || value === 'members_and_clients' ? value : '';

export type ProjectSearchFilters = {
  assignee: string[];
  comments: ProjectSearchCommentsFilter;
  createdAt: string;
  createdAtOperator: ProjectSearchDateOperator;
  createdBy: string[];
  dueDate: string;
  dueDateOperator: ProjectSearchDateOperator;
  involves: string[];
  page: string;
  severity: string[];
  status: string[];
  tag: string[];
  tagMatch: ProjectSearchTagMatch;
  visibility: ProjectSearchVisibilityFilter;
};

export const emptyProjectSearchFilters = (): ProjectSearchFilters => ({
  assignee: [],
  comments: '',
  createdAt: '',
  createdAtOperator: 'on',
  createdBy: [],
  dueDate: '',
  dueDateOperator: 'on',
  involves: [],
  page: '',
  severity: [],
  status: [],
  tag: [],
  tagMatch: 'any',
  visibility: ''
});

export const hasProjectSearchFilters = (filters: ProjectSearchFilters) =>
  filters.assignee.length > 0 ||
  filters.comments === 'unread' ||
  !!filters.createdAt ||
  filters.createdBy.length > 0 ||
  !!filters.dueDate ||
  filters.involves.length > 0 ||
  !!filters.page ||
  filters.severity.length > 0 ||
  filters.status.length > 0 ||
  filters.tag.length > 0 ||
  !!filters.visibility;

export const countProjectSearchFilters = (filters: ProjectSearchFilters) =>
  filters.assignee.length + filters.involves.length;

export const countActiveProjectSearchFilters = (
  filters: ProjectSearchFilters
) =>
  filters.assignee.length +
  (filters.comments === 'unread' ? 1 : 0) +
  (filters.createdAt ? 1 : 0) +
  filters.createdBy.length +
  (filters.dueDate ? 1 : 0) +
  filters.involves.length +
  (filters.page ? 1 : 0) +
  filters.severity.length +
  filters.status.length +
  filters.tag.length +
  (filters.visibility ? 1 : 0);
